/**
 * Counts the number of decimal places in a number,
 * even if it's represented in scientific notation,
 * including trailing zeros.
 */
export function countDecimals(amount: number | string): number {
  const match = ('' + amount).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/)

  if (!match) {
    return 0
  }
  const decPart = match[1] ?? ''
  const expPart = match[2] ? parseInt(match[2], 10) : 0
  return Math.max(0, decPart.length - expPart)
}
